import { render, staticRenderFns } from "./FocusBackground.vue?vue&type=template&id=9b0291ee"
import script from "./FocusBackground.vue?vue&type=script&lang=js"
export * from "./FocusBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports